// app/src/components/SignUpPageDesktopPro.tsx

import React, { useState, useEffect } from 'react';
import { Dialog } from '@mui/material';
import { useTranslation } from 'react-i18next';
import SignUpPageDesktopProPanel1 from './SignUpPageDesktopProPanel1';
import SignUpPageDesktopProPanel2 from './SignUpPageDesktopProPanel2';
import SignUpPageDesktopProPanel3 from './SignUpPageDesktopProPanel3';
import { useAuthContext } from "../../../contexts/AuthContext";
import { useScaleMobile } from "../../../contexts/ScaleContextMobile";


const SignUpPageDesktopPro = () => {
	const { scaleMobile } = useScaleMobile();
	const { t } = useTranslation();
	const {
		userInfo,
		loadUserInfoFromLocalStorage,
		setUserInfo,
		handleSignUpPro,
	} = useAuthContext();
	const [isDialogOpen, setIsDialogOpen] = useState(false);
	
	const handleDialogClose = () => {
		setIsDialogOpen(false);
	};
	
	const handleConfirmDelete = () => {
		setUserInfo({
			...userInfo,
			documents: {
				companyRegistration: [],
				identityCard: [],
				identityCardBack: [],
				other: [],
			},
		});
		setIsDialogOpen(false);
		handleSignUpPro();
	};
	
	useEffect(() => {
		if (!userInfo?.contact?.email) {
			loadUserInfoFromLocalStorage('');
		}
	}, []);
	
	if (!userInfo?.contact?.email) {
		return <></>;
	}
	
	return (
		<div
			style={{
				width: 1761,
				background: '#ECECEC',
				borderRadius: 32,
				display: 'flex',
				flexDirection: 'column',
				alignItems: 'center',
				color: '#323E48',
				paddingBottom: 60,
				marginBottom: 20,
			}}
		>
			<div
				style={{
					marginTop: 60,
					height: 80,
					padding: '0 50px',
					background: '#FF4D00',
					color: '#FFFFFF',
					letterSpacing: 0,
					fontSize: 47,
					fontWeight: 'bold',
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'center',
				}}
			>
				<div style={{ marginTop: '-5px' }}>
					{t('page2SignUp:signup_title')}
				</div>
			</div>
			<div
				style={{
					marginTop: 32,
					height: 30,
					fontSize: 25,
					fontWeight: 'bold',
				}}
			>
				{t('page2SignUp:signup_steps')}
			</div>
			
			<SignUpPageDesktopProPanel1 />
			<SignUpPageDesktopProPanel2 />
			<SignUpPageDesktopProPanel3 />
			
			<Dialog
				open={isDialogOpen}
				onClose={handleDialogClose}
				PaperProps={{
					style: {
						width: 725,
						transform: `scale(${scaleMobile})`,
						transformOrigin: 'top',
						transition: 'transform 0.3s ease, padding 0.3s ease',
					},
				}}
			>
				<div
					style={{
						height: 466,
						width: 725,
						fontSize: 22,
						overflow: 'hidden',
						color: '#323E48',
					}}
				>
					<div
						style={{
							height: 391,
							width: '100%',
							margin: '38px 0',
							position: 'relative',
							display: 'flex',
							flexDirection: 'column',
							alignItems: 'center',
						}}
					>
						<div
							style={{
								width: 286,
								height: 46,
								background: '#FF4D00',
								color: '#FFFFFF',
								fontWeight: 'bold',
								display: 'flex',
								alignItems: 'center',
								justifyContent: 'center',
								fontSize: 29,
								textTransform: 'uppercase',
							}}
						>
							{t('page2SignUp:dialog_attention')}
						</div>
						<div style={{ position: 'absolute', top: 80 }}>
							{t('page2SignUp:dialog_provide_later')} <span
							style={{ textDecoration: 'underline', fontWeight: 'bold' }}>{t('page2SignUp:dialog_provide_later_underline')}</span> ?
						</div>
						<div
							style={{
								position: 'absolute',
								top: 112,
								width: 200,
								height: 1,
								background: '#FF4D00',
							}}
						/>
						<div style={{ position: 'absolute', top: 164 }}>
							{t('page2SignUp:dialog_clicked_provide_later')}
						</div>
						<div
							style={{
								textDecoration: 'underline',
								position: 'absolute',
								top: 192,
								fontWeight: 500,
							}}
						>
							{t('page2SignUp:dialog_docs_deleted')}
						</div>
						<div
							style={{
								fontWeight: 'bold',
								position: 'absolute',
								top: 291,
							}}
						>
							{t('page2SignUp:dialog_confirm_delete')}
						</div>
						<div
							style={{
								position: 'absolute',
								bottom: 0,
								display: 'flex',
								flexDirection: 'row',
								justifyContent: 'center',
								gap: 71,
							}}
						>
							<button
								style={{
									padding: '0px 32px',
									height: 43,
									borderRadius: 10,
									boxShadow: 'inset 0px 3px 6px #00000029',
									background: '#ffffff',
									color: '#323E48',
									border: '2px solid #FF4D00',
									fontSize: 18,
									fontWeight: 'bold',
									cursor: 'pointer',
									textTransform: 'uppercase',
								}}
								onClick={handleConfirmDelete}
							>
								{t('page2SignUp:dialog_yes_delete')}
							</button>
							<button
								style={{
									padding: '0px 32px',
									height: 43,
									borderRadius: 10,
									backgroundColor: '#FF4D00',
									color: '#FFFFFF',
									border: 'none',
									fontSize: 18,
									fontWeight: 'bold',
									cursor: 'pointer',
									textTransform: 'uppercase',
								}}
								onClick={handleDialogClose}
							>
								{t('page2SignUp:dialog_no_cancel')}
							</button>
						</div>
					</div>
				</div>
			</Dialog>
		</div>
	);
};

export default SignUpPageDesktopPro;
